import React, { useEffect, useState, Component } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2, X } from 'lucide-react';
// Live Buyer Popup Component
const NAMES = ['Martín', 'Carolina', 'Federico', 'Sofía', 'Diego', 'Laura', 'Juan', 'Agustina', 'Lucas', 'Camila', 'Tomás', 'Valentina', 'Matías', 'Julieta', 'Nicolás'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Tucumán', 'Salta', 'Neuquén', 'Bariloche', 'Santa Fe', 'San Juan', 'Resistencia', 'Posadas', 'Corrientes'];
export function BuyerPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [buyer, setBuyer] = useState({
    name: '',
    city: '',
    time: 1
  });
  useEffect(() => {
    // First popup appears after 30s, then repeats every 30s
    const initialTimer = setTimeout(() => {
      showRandomBuyer();
    }, 30000);
    return () => clearTimeout(initialTimer);
  }, []);
  const showRandomBuyer = () => {
    const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
    const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
    const randomTime = Math.floor(Math.random() * 15) + 1; // 1 to 15 mins ago
    setBuyer({
      name: randomName,
      city: randomCity,
      time: randomTime
    });
    setIsVisible(true);
    // Hide after 5 seconds visible, then schedule next one 25s later (= 30s cycle)
    setTimeout(() => {
      setIsVisible(false);
      setTimeout(showRandomBuyer, 25000);
    }, 5000);
  };
  return <AnimatePresence data-id="element-108">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-6 left-6 z-50 bg-white rounded-xl shadow-2xl border border-slate-200 p-4 pr-10 max-w-sm flex items-center gap-4" data-id="element-109">
          <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-slate-400 hover:text-slate-600" data-id="element-110">
            <X className="w-4 h-4" data-id="element-111" />
          </button>

          <div className="w-10 h-10 rounded-full bg-emerald-100 text-emerald-700 flex items-center justify-center font-bold text-sm flex-shrink-0" data-id="element-112">
            {buyer.name.charAt(0)}
          </div>

          <div data-id="element-113">
            <p className="text-sm text-slate-800 font-medium leading-tight mb-1" data-id="element-114">
              <span className="font-bold" data-id="element-115">{buyer.name}</span> de {buyer.city}{' '}
              acaba de comprar PADEL 360
            </p>
            <div className="flex items-center gap-1 text-xs text-slate-500" data-id="element-116">
              <CheckCircle2 className="w-3 h-3 text-emerald-500" data-id="element-117" />
              <span data-id="element-118">Verificado • hace {buyer.time} min</span>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}
// Sticky CTA Component
export function StickyCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show sticky CTA after scrolling past hero section (approx 600px)
      // Hide it when reaching the pricing section to avoid double CTAs
      const scrollY = window.scrollY;
      const pricingSection = document.getElementById('pricing');
      if (pricingSection) {
        const pricingTop = pricingSection.offsetTop;
        setIsVisible(scrollY > 600 && scrollY < pricingTop - 500);
      } else {
        setIsVisible(scrollY > 600);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <AnimatePresence data-id="element-119">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 100
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 100
    }} className="fixed bottom-6 right-6 z-40 hidden md:block" data-id="element-120">
          <button onClick={scrollToPricing} className="bg-emerald-600 hover:bg-emerald-700 text-white font-heading font-bold py-4 px-8 rounded-full shadow-2xl shadow-emerald-600/30 transition-transform hover:scale-105 flex items-center gap-2 uppercase tracking-wide text-lg" data-id="element-121">
            Quiero el pack →
          </button>
        </motion.div>}
    </AnimatePresence>;
}